import { Link } from "react-router-dom";

const Footer = () => {
  return (
    <>
      <footer className="footer">
        <div className="container-fluid">
          <div className="row">
            <div className="col">
              <div className="footer-widget">
                <h6 className="footer-widget-title">QUICK LINKS</h6>
                <ul>
                  <li>
                    <Link to="/faqs">FAQs</Link>
                  </li>
                  <li>
                    <Link to="/privacy-policy">Returns Policy </Link>
                  </li>
                  <li>
                    <a href="#">Afterpay</a>
                  </li>
                  <li>
                    <a href="#">In-Store Perks</a>
                  </li>
                  <li>
                    <a href="#">Contact Us</a>
                  </li>
                </ul>
              </div>
            </div>
            <div className="col">
              <div className="footer-widget">
                <h6 className="footer-widget-title">ABOUT DRESS UP</h6>
                <ul>
                  <li>
                    <Link to="/about-us">Our Vision & Mission</Link>
                  </li>
                  <li>
                    <a href="#">Careers</a>
                  </li>
                  <li>
                    <a href="#">Collaborations</a>
                  </li>
                  <li>
                    <a href="#">it-girl: Campus Rep Program</a>
                  </li>
                  <li>
                    <a href="#">Blog</a>
                  </li>
                </ul>
              </div>
            </div>
            <div className="col">
              <div className="footer-widget">
                <h6 className="footer-widget-title">GET SHOPPING</h6>
                <ul className="footer-info-list">
                  <li>
                    <a href="#">Just Arrived</a>
                  </li>
                  <li>
                    <a href="#">Clothing</a>
                  </li>
                  <li>
                    <a href="#">Accessories</a>
                  </li>
                  <li>
                    <a href="#">Sale</a>
                  </li>
                  <li>
                    <a href="#">Gift Cards</a>
                  </li>
                </ul>
              </div>
            </div>
            <div className="col">
              <div className="footer-widget">
                <h6 className="footer-widget-title">CONNECT WITH US</h6>
                <ul className="footer-info-list">
                  <li>
                    <a href="#">Facebook</a>
                  </li>
                  <li>
                    <a href="#">Twitter</a>
                  </li>
                  <li>
                    <a href="#">Youtube</a>
                  </li>
                  <li>
                    <a href="#">Instagram</a>
                  </li>
                </ul>
              </div>
            </div>
            <div className="col">
              <div className="footer-widget">
                <h6 className="footer-widget-title">PAYMENT METHODS</h6>
                <div className="payment-option">
                  <img src="images/payment-option.png" alt="payment-option" />
                </div>
              </div>
            </div>
          </div>
          <div className="footer-bottom border-top">
            <div className="row">
              <div className="col-lg-3 col-sm-12 col-xs-12">
                <div className="site-logo footer-logo">
                  <Link to="/">
                    <img
                      src="neerthreadlogo.jpg"
                      alt="logo"
                      style={{ maxWidth: "20%" }}
                    />
                  </Link>
                </div>
              </div>
              <div className="col-lg-5 col-sm-12 col-xs-12 align-self-center">
                <div className="default-menu text-center">
                  <ul className="list-style mb-0">
                    <li>
                      <Link to="/faqs">Faq</Link>
                    </li>
                    <li>
                      <Link to="/privacy-policy">Privacy Policy</Link>
                    </li>
                    <li>
                      <Link to="/about-us">About Us</Link>
                    </li>
                    <li>
                      <Link to="/instructions">Instructions About theme</Link>
                    </li>
                    <li>
                      <Link to="/location">Locations</Link>
                    </li>
                    <li>
                      <Link to="/privacy-policy">Accessibility</Link>
                    </li>
                  </ul>
                </div>
              </div>
              <div className="col-lg-4 col-sm-12 col-xs-12 align-self-center">
                <p className="mb-0 text-right col-xs-text-center">
                  © 2021 fashion Hub – AN ONLINE DRESS BOUTIQUE.
                </p>
              </div>
            </div>
          </div>
        </div>
        <div className="footer-bar">
          <div className="text-center">
            <p className="mb-0">
              Our group is glad to respond to any inquiries. For help, look at
              our <a href="faq.html">FAQ</a> or{" "}
              <a href="emailtto:contact@gmail.com">e-mail us</a>.We are always
              willing to assist.
            </p>
          </div>
        </div>
      </footer>

      <a href="#" id="scroll" className="back-to-top">
        <span>
          <i className="lni lni-arrow-up" />
        </span>
      </a>

      <div className="modal fade" id="modalshow">
        <div className="modal-dialog modal-dialog-centered modal-lg">
          <div className="modal-content">
            <div className="modal-header">
              <button
                type="button"
                className="close"
                data-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">
                  {" "}
                  <i className="lni lni-close" />{" "}
                </span>
              </button>
            </div>
            <div className="modal-body">
              <div className="row m-0">
                <div className="col-lg-5 col-sm-12 col-xs-12">
                  <div className="owl-sticky">
                    {/*Carousel Wrapper*/}
                    <div id="sync1" className="owl-carousel owl-theme">
                      <div className="item">
                        <a data-fancybox="gallery" href="images/prd-1.jpg">
                          <img
                            className="d-block w-100"
                            src="images/prd-1.jpg"
                            alt="First slide"
                          />
                        </a>
                      </div>
                      <div className="item">
                        <a href="images/prd-2.jpg" data-fancybox="gallery">
                          <img
                            className="d-block w-100"
                            src="images/prd-2.jpg"
                            alt="First slide"
                          />
                        </a>
                      </div>
                      <div className="item">
                        <a href="images/prd-3.jpg" data-fancybox="gallery">
                          <img
                            className="d-block w-100"
                            src="images/prd-3.jpg"
                            alt="First slide"
                          />
                        </a>
                      </div>
                      <div className="item">
                        <a data-fancybox="gallery" href="images/prd-1.jpg">
                          <img
                            className="d-block w-100"
                            src="images/prd-1.jpg"
                            alt="First slide"
                          />
                        </a>
                      </div>
                      <div className="item">
                        <a href="images/prd-2.jpg" data-fancybox="gallery">
                          <img
                            className="d-block w-100"
                            src="images/prd-2.jpg"
                            alt="First slide"
                          />
                        </a>
                      </div>
                      <div className="item">
                        <a href="images/prd-3.jpg" data-fancybox="gallery">
                          <img
                            className="d-block w-100"
                            src="images/prd-3.jpg"
                            alt="First slide"
                          />
                        </a>
                      </div>
                    </div>
                    <div id="sync2" className="owl-carousel owl-theme xl-arrow">
                      <div className="item">
                        <img
                          className="d-block w-100"
                          src="images/prd-1.jpg"
                          alt="First slide"
                        />
                      </div>
                      <div className="item">
                        <img
                          className="d-block w-100"
                          src="images/prd-2.jpg"
                          alt="First slide"
                        />
                      </div>
                      <div className="item">
                        <img
                          className="d-block w-100"
                          src="images/prd-3.jpg"
                          alt="First slide"
                        />
                      </div>
                      <div className="item">
                        <img
                          className="d-block w-100"
                          src="images/prd-1.jpg"
                          alt="First slide"
                        />
                      </div>
                      <div className="item">
                        <img
                          className="d-block w-100"
                          src="images/prd-2.jpg"
                          alt="First slide"
                        />
                      </div>
                      <div className="item">
                        <img
                          className="d-block w-100"
                          src="images/prd-3.jpg"
                          alt="First slide"
                        />
                      </div>
                    </div>
                  </div>
                  {/*/.Carousel Wrapper*/}
                </div>
                {/* col */}
                <div className="col-lg-7 col-sm-12 col-xs-12">
                  <div className="quickview-product">
                    <div className="prd-info">
                      <h4 className="prd-name">
                        Astronet Cotton Blended Regular Tops -
                        <span className="prd-color">Black</span>
                      </h4>
                      <div className="quickview-content">
                        <p>
                          Lorem Ipsum is only the typesetting and printing
                          industry's equivalent of dummy text. Since the 1500s,
                          when an unidentified printer first used Lorem Ipsum,
                          it has been the industry standard for fictitious text.
                        </p>
                        <ul className="prd-point">
                          <li>Set Contents:With 2-piece</li>
                          <li>Color: Black</li>
                          <li>Toop Fabric: Georgette </li>
                          <li>Fabric: Georgette </li>
                        </ul>
                        <p>Measurements for garments in inches:</p>
                        <p className="fs-11">
                          Little | Bust 34” | Waist 28” (Stretches up to 40") |
                          Hips 46” | Length 33” Medium | Bust 36” | Waist 30”
                          (Stretches up to 42") | Hips 49” | Length 34” Large |
                          Bust 38” | Waist 32” (Stretches up to 44") | Hips 52”
                          | Length 35”
                        </p>
                        <p className="tcolor">
                          Have questions about sizing, fit, or styling? Send us
                          a chat or give us a call at 000-999-1111 during
                          business hours 9 AM - 5 PM EST Monday-Friday!
                        </p>
                      </div>
                      <div className="quick-view-box fs-13 border">
                        <div className="row">
                          <div className="col-lg-6 col-sm-6 col-xs-12">
                            <div className="prices">
                              <p>prices</p>
                              <span>$30</span> <del>$70</del>{" "}
                              <span className="tcolor">63% Off</span>
                            </div>
                            <div className="color-option text-left">
                              <ul className="list-style">
                                <li>
                                  <label>
                                    <input
                                      type="radio"
                                      name="color-option"
                                      defaultChecked=""
                                      defaultValue="white"
                                    />
                                    <span
                                      className="form-option-variant"
                                      style={{ background: "#fbc101" }}
                                    />
                                  </label>
                                </li>
                                <li>
                                  <label>
                                    <input
                                      type="radio"
                                      name="color-option"
                                      defaultValue="black"
                                    />
                                    <span
                                      className="form-option-variant"
                                      style={{ background: "#b41e4e" }}
                                    />
                                  </label>
                                </li>
                                <li>
                                  <label>
                                    <input
                                      type="radio"
                                      name="color-option"
                                      defaultValue="red"
                                    />
                                    <span
                                      className="form-option-variant"
                                      style={{ background: "#f0afaf" }}
                                    />
                                  </label>
                                </li>
                              </ul>
                            </div>
                            <div className="prd-size">
                              <p>Size: Required</p>
                              <ul className="list-style">
                                <li>
                                  <label>
                                    <input
                                      type="radio"
                                      name="size-option"
                                      defaultChecked=""
                                      defaultValue="Small"
                                    />
                                    <span className="pd-size-option">
                                      Small
                                    </span>
                                  </label>
                                </li>
                                <li>
                                  <label>
                                    <input
                                      type="radio"
                                      name="size-option"
                                      defaultValue="Medium"
                                    />
                                    <span className="pd-size-option">
                                      Medium
                                    </span>
                                  </label>
                                </li>
                                <li>
                                  <label>
                                    <input
                                      type="radio"
                                      name="size-option"
                                      defaultValue="Large"
                                    />
                                    <span className="pd-size-option">
                                      Large
                                    </span>
                                  </label>
                                </li>
                              </ul>
                            </div>
                            <div className="quantity-box">
                              <p>Quantity</p>
                              <div className="number-input md-number-input">
                                <button
                                  onclick="this.parentNode.querySelector('input[type=number]').stepDown()"
                                  className="minus icon-btn"
                                >
                                  <i className="lni lni-minus" />
                                </button>
                                <input
                                  className="quantity form-control"
                                  min={0}
                                  name="quantity"
                                  defaultValue={1}
                                  type="number"
                                />
                                <button
                                  onclick="this.parentNode.querySelector('input[type=number]').stepUp()"
                                  className="plus icon-btn"
                                >
                                  <i className="lni lni-plus" />
                                </button>
                              </div>
                            </div>
                            <div className="action-box">
                              <button>Add to Cart</button>
                              <button>Add to WishList</button>
                            </div>
                          </div>
                          <div className="col-lg-6 col-sm-6 col-xs-12 align-self-center">
                            <div className="store-box">
                              <span className="sm-btn bg-green text-white">
                                Available online
                              </span>
                              <div className="location-box bg-light  p-4 mt-4">
                                <p>Buy Online and Pick Up In Store</p>
                                <div className="cart-nav text-left  mb-3">
                                  <div className="store-search text-left">
                                    <h6>Select a Store</h6>
                                    <p className="fs-13 text-left">
                                      <span className="material-icons">
                                        location_on
                                      </span>
                                      <a href="#">Use my current location</a>
                                    </p>
                                    <form>
                                      <input
                                        type="text"
                                        name="zip"
                                        placeholder="Enter zipcode or state"
                                        className="form-control"
                                      />
                                    </form>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    {/* col */}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Footer;
